import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedTours from './components/FeaturedTours';
import PopularDestinations from './components/PopularDestinations';
import WhyChooseUs from './components/WhyChooseUs';
import StatsSection from './components/StatsSection';
import TestimonialsPreview from './components/TestimonialsPreview';
import CTASection from './components/CTASection';
import BusTicketingBanner from './components/BusTicketingBanner';

export default function Home() {
  return (
    <main>
      <Navbar />
      <HeroSection />
      <FeaturedTours />
      <PopularDestinations />
      <BusTicketingBanner />
      <WhyChooseUs />
      <StatsSection />
      <TestimonialsPreview />
      <CTASection />
      <Footer />
    </main>
  );
}
